import theme from '../default';

export default {
    root: {
        padding: theme.spacing(2),
    },
};
